import { useState, useEffect } from "react";
import { useQuery } from "@apollo/client";
import { GET_DISTRICT_BY_PROVINCE } from "../Schema/SelectSchema";

export const useGetDistrictByProvice = ({ capicalProvincesId }) => {
  const [loading, setLoading] = useState(true);
  const [tableData, setTableData] = useState();

  const { refetch } = useQuery(GET_DISTRICT_BY_PROVINCE, {
    variables: {
      capicalProvincesId: capicalProvincesId,
    },
    onCompleted: ({ getDistrictByProvice }) => {
    
      setTableData(getDistrictByProvice || []);
      setLoading(false);
    },
    onError: (err) => {
      console.log("Error::", err?.message);
    },
  });

  useEffect(() => {
    refetch();
  }, []);

  return { tableData, loading, refetch };
};
